var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 10.188,
    viewBox: "0 0 11.5 10.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85977",
    "data-name": "Group 85977",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124974",
    "data-name": "Path 124974",
    d: "M56.955,39.348A1.757,1.757,0,0,0,55.207,37.8H53.982a1.756,1.756,0,0,0-1.737,1.548l-.167,1.425a.358.358,0,0,0,.278.4c.167.033.334.067.512.089l1.3-.98a.895.895,0,0,1,1.381.423l.212.635c.379-.045.746-.089,1.1-.167a.368.368,0,0,0,.278-.4Z",
    transform: "translate(-46.552 -34.07)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1318",
    "data-name": "Ellipse 1318",
    cx: 1.648,
    cy: 1.648,
    r: 1.648,
    transform: "translate(6.406 0)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124975",
    "data-name": "Path 124975",
    d: "M5.619,62.5H4.394a1.767,1.767,0,0,0-1.748,1.548l-.167,1.425a.368.368,0,0,0,.278.4,10.478,10.478,0,0,0,2.249.234,10.553,10.553,0,0,0,2.249-.234.368.368,0,0,0,.278-.4l-.167-1.425A1.757,1.757,0,0,0,5.619,62.5Z",
    transform: "translate(-2.477 -56.019)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1319",
    "data-name": "Ellipse 1319",
    cx: 1.648,
    cy: 1.648,
    r: 1.648,
    transform: "translate(0.882 2.751)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124976",
    "data-name": "Path 124976",
    d: "M56.657,64.669a.224.224,0,0,0-.345-.111l-1.492,1.125a.229.229,0,0,0,.067.4l.423.134a3.089,3.089,0,0,1-1.225,1.57.1.1,0,0,0,.033.178,2.183,2.183,0,0,0,2.428-1.381l.434.134a.222.222,0,0,0,.278-.29Z",
    transform: "translate(-48.302 -57.809)",
    fill: "#dcf8c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125237",
    "data-name": "Path 125237",
    d: "M14.675,10.353a.226.226,0,0,1-.16-.066l-.452-.452a.227.227,0,0,1,.321-.321l.292.294.744-.746a.227.227,0,1,1,.321.321l-.9.9A.226.226,0,0,1,14.675,10.353Z",
    transform: "translate(-4.306 -6.622)",
    fill: "#1e9d60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.c6ecbd6a68a2318cc11d8787125dcf2f.svg";
export { ForwardRef as ReactComponent };